import type { UserCardStage } from "@-/dev.improve.haniverse.constants.user-card-stage";

/**
 * SRS stage for a single grapheme — drives the `stage` background color in
 * `morphemeGlyphTileVariants`. Spans the SRS `UserCardStage` values plus
 * `"unadded"` (the user has not added any card for this grapheme yet).
 */
export const MORPHEME_GLYPH_TILE_STAGE = [
  "unadded",
  "new",
  "familiar",
  "proficient",
  "mastered",
] as const;

export type MorphemeGlyphTileStage = (typeof MORPHEME_GLYPH_TILE_STAGE)[number];

/**
 * Map an SRS stage to the corresponding tile `stage`. The `UserCardStage`
 * values share the tile-stage names one-to-one; `"unadded"` is not reachable
 * from a `UserCardStage` and is returned by the caller directly when a grapheme
 * has no user cards at all.
 */
export function getMorphemeGlyphTileStageFromUserCardStage(
  stage: UserCardStage,
): MorphemeGlyphTileStage {
  return stage;
}
